/* eslint-disable @typescript-eslint/camelcase */
export const defaultScheme = (isTemplate: boolean, isXTMEnabled: boolean, isQuestionSet: boolean,
    isItemReviewEnabled: boolean, {
        isPreviewSet = true,
        isItemReviewSet = true,
        isAuthorEditSet = true,
    }) => {
    const itemReviewForAuthor = (isItemReviewEnabled || isXTMEnabled) && isItemReviewSet ? [{
        // Prefer XTM when enabled, otherwise fall back to legacy review
        internal_ref: isXTMEnabled ? 'item_review_xtm' : 'item_bank_default',
        visible: !isTemplate && isItemReviewSet,
    }] : [];

    return {
        schemeId: 'internal_test_scheme',
        name: {
            no_no: 'Inspera beta workspace skjema',
            en_us: 'Inspera beta workspace scheme',
        },
        workspaceGroups: [
            {
                type: 'system_role_testauthor_rel',
                workspaces: [
                    {
                        internal_ref: 'author_edit',
                        visible: isAuthorEditSet,
                    },
                    {
                        internal_ref: 'author_preview',
                        visible: isPreviewSet,
                    },
                    ...itemReviewForAuthor,
                ],
            },
            {
                type: 'system_role_testextendedcontentadmin_rel',
                workspaces: [
                    {
                        internal_ref: 'item_bank_default',
                        visible: !isTemplate && isItemReviewEnabled && !isQuestionSet,
                    },
                    {
                        internal_ref: 'item_review_xtm',
                        visible: isXTMEnabled && !isTemplate && !isQuestionSet,
                    },
                ],
            },
        ],
    };
};
